export const langTitles: Record<string, string> = {
  ru: 'Ru',
  en: 'En',
};
